  <div *ngIf="!hidden" id="neptune-filter-select" class="mr-6">
    <div class="filter-selection-header flex flex-row">
      <div class="font-normal text-sm">
        {{ title }} <span *ngIf="required">(Required)</span>
      </div>
      <loader class="loader pl-4" size="small" *ngIf="isLoading"></loader>
    </div>

    <div class="filter-selection-container">
      <ng-container *ngIf="isMultiple; else singleSelect">
        <mat-form-field appearance="outline" class="w-full" floatLabel="auto">

          <mat-select
            placeholder ="Select"
            [required]="required"
            [disabled]="disabled"
            [(ngModel)]="DOMSelected"
            (openedChange)="resetToTop()"
            (selectionChange)="onChange($event)"
            panelClass="panel"
            multiple
          >
            <mat-select-trigger>
              <span
                *ngIf="currentlySelected.length >= 3; else singleSpan"
                class="multi-select-label"
              >
                Multiple Selected
              </span>
              <ng-template #singleSpan>
                <span>
                  {{ currentlySelected }}
                </span>
              </ng-template>
            </mat-select-trigger>

            <div class="flex p-4 gap-4" [ngClass]="title==='Countries' ? 'flex-row' : 'flex-col'">
              <div class="border-1 border-black border-solid rounded-md flex" [ngClass]="title==='Countries' ? 'flex-grow' : 'w-full'">
                <img src="assets/gray-search-icon.png" class="w-4 h-4 p-2" alt="search-icon">
                <input
                  class="search-options-input"
                  type="text"
                  placeholder="{{ title === 'Countries' ? 'Search Countries' : 'Search' }}"
                  (input)="onSearchInput()"
                  [(ngModel)]="searchInput"
                  (keydown)="$event.stopPropagation()"
                  matInput
                />
              </div>

              <div class="flex flex-row justify-between items-center" [ngClass]="title==='Countries' ? 'w-max' : 'w-full'">

                <label class="flex gap-1 text-sm">
                  <input
                    name="selectAllCheckbox"
                    type="checkbox"
                    [(ngModel)]="isSelectAllChecked"
                    (change)="updateSelectionFromCheckbox($event)"
                    class="neptune-checkbox w-[18px] h-[18px] items-center"
                  />
                  <span class="flex items-center">
                    Select All
                  </span>
                </label>

                <!-- Disable for countries  -->
                <ng-container *ngIf="title != 'Countries'">
                  <button
                    class="flex gap-2 text-sm text-blue bg-white"
                    (click)="viewSelectedOptions()"
                    *ngIf="currentView == 'all'"
                  >
                    <img src="/assets/eye-icon.svg" alt="eye-icon" />
                    View Selected
                  </button>
                  <button
                    class="flex gap-2 text-sm text-blue bg-white"
                    (click)="returnToAllOptions()"
                    *ngIf="currentView == 'view selected'"
                  >
                  Return to all
                </button>
                </ng-container>

                <button class="text-sm cursor-pointer text-blue bg-white" (click)="clearAllOptions()">
                  Clear All
                </button>

              </div>
            </div>

            <cdk-virtual-scroll-viewport
              class="virtual-scroll-container h-[200px]"
              [itemSize]="10"
              [minBufferPx]="200"
              [maxBufferPx]="500"
              #scrollViewport
            >
              <mat-option *ngIf="isOptionListEmpty(listToDisplay)" disabled="true" >
                No Data Available
              </mat-option>
              <ng-container *cdkVirtualFor="let option of listToDisplay" >
                <mat-option [value]="option" class="border-l-4 border-white hover:border-l-blue">{{ option }}</mat-option>
              </ng-container>
            </cdk-virtual-scroll-viewport>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-template #singleSelect>
        <ng-container *ngIf="title != 'Date Range'; else dateRangeSelect">
          <mat-form-field appearance="outline" class="w-full" floatLabel="auto">

            <mat-select
              placeholder = "Select"
              [required]="required"
              [disabled]="disabled"
              [ngModel]="title === 'Region' ? selectedRegion : currentlySelected"
              (ngModelChange)="title === 'Region' ? selectedRegion : currentlySelected = $event"
              (selectionChange)="title === 'Region' ? onChange($event) : selectOptions()"
              panelClass="panel panel-single-select"
            >
              <ng-container *ngFor="let option of listToDisplay">
                <mat-option [value]="option" class="border-l-4 border-white hover:border-l-blue">
                  {{ option }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </ng-container>
        <ng-template #dateRangeSelect>
          <!-- List of radio buttons with date options -->
          <div class="flex flex-row gap-4">
            <ng-container *ngFor="let option of listToDisplay">
              <label class="flex items-center gap-4 text-sm pt-4">
                <input
                  [id]="getSanitizedFilterId(option)"
                  type="radio"
                  name="dateRange"
                  [value]="option"
                  [(ngModel)]="currentlySelected"
                  (change)="selectOptions()"
                  class="neptune-radio-button w-[18px] h-[18px] items-center"
                />
                {{ option }}
              </label>
            </ng-container>
          </div>
        </ng-template>
      </ng-template>

    </div>

    <div class="filter-selection-footer text-xs" [ngClass]="title === 'Date Range' && divDataView != 'Distributor' ? '' : 'pb-6'">
      <span *ngIf="!isLoading && isMultiple && currentlySelected.length > 0"> {{ currentlySelected.length }} {{title == "Countries" ? "Country" : ""}} Selected</span>
    </div>

  </div>
